export const toastSuccess = (title: string, description: string) => {
	const toast = useToast();
	return toast.add({
		title,
		description,
		color: 'success'
	});
};
